export default "__VITE_ASSET__DM$pxvv8__"